module.exports = __webpack_public_path__ + "img/p9-p1-chuan.73c030f3.png";